import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";

const initialStates = [
  {
    name: "app.registration.customer",
    url: "/clientes",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 100,
        name: "Clientes",
        state: "app.registration.customer"
      },
      authorization: context =>
        context.user.permissions.includes("manage_customers")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/index.js